import { createApp, type Component } from 'vue';

import App from './app/App.vue';
import './styles/global.css';

// Come in `apps/web`: `App.vue` è tipizzato dal plugin Vue del bundler, non dal
// solo `tsc`, quindi l'annotazione qui è esplicita.
createApp(App as Component).mount('#app');
